import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import NavBar from './components/NavBar';
import './styles/App.css'
import './styles/AdminShell.css';
import './styles/AdminSurface.css';
import Users from "./components/route_pages/Users";
import Tables from "./components/route_pages/Tables";
import { AdminProvider } from "./context/AdminContext";
import Menus from "./components/route_pages/Menus";
import Categories from "./components/route_pages/Categories";
import Items from "./components/route_pages/Items";
import Floors from "./components/route_pages/Floors";
import Areas from "./components/route_pages/Areas";
import Profile from "./components/route_pages/Profile";
import Statistics from "./components/route_pages/Statistics";
import Shifts from "./components/route_pages/Shifts";
import Audit from "./components/route_pages/Audit";
import './styles/common.css';

const App = () => (
  <Router>
    <AdminProvider>
      <div className="app-container">
        <NavBar />
        <main className="main-content">
          <div className="main-content-inner">
            <Routes>
              <Route path="/admin/users" element={<Users />} />
              <Route path="/admin/areas" element={<Areas />} />
              <Route path="/admin/menus" element={<Menus />} />
              <Route path="/admin/categories" element={<Categories />} />
              <Route path="/admin/items" element={<Items />} />
              <Route path="/admin/tables" element={<Tables />} />
              <Route path="/admin/floors" element={<Floors />} />
              <Route path="/admin/statistics" element={<Statistics />} />
              <Route path="/admin/shifts" element={<Shifts />} />
              <Route path="/admin/audit" element={<Audit />} />
              <Route path="/admin/profile" element={<Profile />} />
              <Route path="/" element={<Navigate to="/admin/users" />} />
            </Routes>
          </div>
        </main>
      </div>
    </AdminProvider>
  </Router>
);

export default App;
